import { getStyleForColor } from "./get-style-for-color.js";
import notification_module_default from "../../../components/notification/notification.module.js";
import { createTheme, defaultVariantColorsResolver, rgba } from "@mantine/core";

//#region src/framework/theme/util/create-theme.ts
const createTheme$1 = (theme) => {
	return createTheme({
		...theme,
		components: { Notification: {
			defaultProps: { radius: "xxs" },
			classNames: notification_module_default
		} },
		other: {
			...theme.other ?? {},
			fontWeights: {
				bold: 600,
				medium: 500,
				regular: 400
			},
			getStyleForColor,
			getActionableIconColor: (actionable) => {
				return getStyleForColor(actionable ? "primary" : "secondary").bg;
			},
			getIconColor: (color) => {
				if (color === "black" || color === "white" || color === "currentColor") return color;
				return getStyleForColor(color).bg;
			},
			getTextColor: (color) => {
				return `var(--mantine-color-${color}-text)`;
			}
		},
		variantColorResolver: (input) => {
			const defaultResolvedColors = defaultVariantColorsResolver(input);
			if (input.color === "high-contrast" || input.color === "high-contrast-inverted") switch (input.variant) {
				case "outline": return {
					background: "transparent",
					hover: rgba(`var(--mantine-color-${input.color}-background)`, .15),
					color: `var(--mantine-color-${input.color}-background)`,
					border: `calc(0.0625rem * var(--mantine-scale)) solid var(--mantine-color-${input.color}-background)`
				};
				case "subtle": return {
					background: "transparent",
					hover: rgba(`var(--mantine-color-${input.color}-background)`, .15),
					color: `var(--mantine-color-${input.color}-background)`,
					border: "none"
				};
				case "filled":
				default: return {
					background: `var(--mantine-color-${input.color}-background)`,
					hover: rgba(`var(--mantine-color-${input.color}-background)`, .15),
					color: `var(--mantine-color-${input.color}-foreground)`,
					hoverColor: `var(--mantine-color-${input.color}-background)`,
					border: "none"
				};
			}
			return defaultResolvedColors;
		}
	});
};

//#endregion
export { createTheme$1 as createTheme };